import {ModalDataI} from '../types/interface/input';

export const modalDataInit: ModalDataI = {
  status: false,
  value: undefined,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange: (value: Date) => undefined,
};
